<template>
  <li>
    <div class="card">
      <div class="head">
        <div class="number">第{{ numberToKanji(number) }}項</div>
        <div class="time" v-if="isTop">30分</div>
      </div>
      <div class="title">{{ data.title }}</div>
      <dl class="last" v-if="isTop && data.last_test_day">
        <dt>最終受験日：</dt>
        <dd>{{ data.last_test_day }}</dd>
        <dt>得点：</dt>
        <dd>{{ data.score }}点/{{ number !== 5 ? '30' : '20' }}点</dd>
      </dl>
      <div class="btnWrap">
        <template v-if="isTop">
          <template v-if="data.last_test_day">
            <Button
              :label="'再受験する'"
              primary
              :handleClick="
                () =>
                  $router.push(`/magazines/exam/cbt/category${number}/detail/1`)
              "
            />
            <Button
              :label="'前回の成績・解答を見る'"
              lightgray
              :handleClick="
                () =>
                  $router.push(`/magazines/exam/cbt/category${number}/result`)
              "
            />
          </template>
          <Button
            v-else
            :label="'受験する'"
            secondary
            :handleClick="
              () =>
                $router.push(`/magazines/exam/cbt/category${number}/detail/1`)
            "
          />
        </template>
        <Button
          v-else
          :label="'成績・解答を見る'"
          lightgray
          :handleClick="
            () => $router.push(`/magazines/exam/cbt/category${number}/result`)
          "
        />
      </div>
    </div>
    <div class="note" v-if="isTop">＊ 再度受験すると成績が更新されます。</div>
  </li>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'CbtAccordion',
  components: {
    Button
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    number: {
      type: Number
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const numberToKanji = (number: number) => {
      const kanji = ['一', '二', '三', '四', '五']
      return kanji[number - 1]
    }

    return {
      numberToKanji
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.card {
  border: 1px solid #e4e4e4;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);
  padding: 20px;
  border-radius: 5px;
  @include mixins.media() {
    display: grid;
    grid-template-columns: 1fr 214px;
    gap: 0 60px;
    padding-right: 60px;
  }
}
.head {
  display: flex;
  align-items: center;
  .number {
    color: var.$color-main-text;
    font-weight: bold;
    font-size: 1.6rem;
    @include mixins.media() {
      font-size: 1.4rem;
    }
  }
  .time {
    margin-left: 7px;
    width: 47px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    font-weight: bold;
    color: var.$color-main-text;
    background-color: var.$color-sub-bg-g;
  }
}
.title {
  margin-top: 8px;
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
}
.last {
  margin-top: 16px;
  background-color: var.$color-other-bg;
  border-radius: 4px;
  padding: 10px;
  display: grid;
  grid-template-columns: 75px 1fr;
  font-size: 1.2rem;
  line-height: 1.5;
  dt {
    text-align: right;
    font-weight: 500;
  }
  dd {
    font-weight: bold;
    color: var.$color-main-text;
  }
}
.btnWrap {
  margin-top: 20px;
  @include mixins.media() {
    margin-top: 0;
    grid-row: 1/3;
    grid-column: 2/3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &.hasLast {
      grid-row: 1/4;
    }
  }
  .button {
    min-height: 40px;
  }
  .button + .button {
    margin-top: 12px;
  }
}
.note {
  margin-top: 12px;
  font-size: 1.2rem;
}
</style>
